import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/BlackProfile.css";
import ApiService from "../nhrc_apis/ApiService"; // ✅ adjust path if needed

function BlackProfile() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBlackProfiles = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await ApiService.HrBlackProfilesAPI.getAllBlackProfiles();
        const result = response?.data;

        const profiles = Array.isArray(result)
          ? result
          : result?.black_profiles || result?.data || [];

        setData(profiles);
      } catch (err) {
        console.error("FETCH BLACK PROFILES ERROR:", err);
        setError("Failed to load black profiles. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchBlackProfiles();
  }, []);

  const handleView = (employee) => {
    navigate("/hrdashboard/BlackProfileView", { state: { employee } });
  };

  const handleDelete = async (profile_id) => {
    if (window.confirm("Do you want to delete this profile?")) {
      try {
        await ApiService.HrBlackProfilesAPI.deleteBlackProfile(profile_id);
        setData((prev) => prev.filter((item) => (item.id || item.profile_id) !== profile_id));
        alert("Profile deleted successfully");
      } catch (err) {
        console.error("DELETE ERROR:", err);
        alert(
          err?.response?.data?.message ||
          err?.response?.data?.detail ||
          "Failed to delete profile. Please try again."
        );
      }
    }
  };

  return (
    <div className="nhrc-bp-page">
      <div className="nhrc-bp-main-content">
        <div className="nhrc-bp-wrapper">
          <div className="nhrc-bp-card">
            <div className="nhrc-bp-header">
              <span>Employee Black Profile</span>
              <button
                className="nhrc-bp-add-btn"
                onClick={() => navigate("/hrdashboard/Blackprofileapplication")}
              >
                + Add Profile
              </button>
            </div>

            <div className="nhrc-bp-table-wrap">

              {/* LOADING */}
              {loading && (
                <h3 style={{ textAlign: "center", padding: "20px" }}>
                  Loading profiles...
                </h3>
              )}

              {/* ERROR */}
              {!loading && error && (
                <h3 style={{ textAlign: "center", padding: "20px", color: "red" }}>
                  {error}
                </h3>
              )}

              {/* EMPTY */}
              {!loading && !error && data.length === 0 && (
                <h3 style={{ textAlign: "center", padding: "20px" }}>
                  No blacklisted profiles found
                </h3>
              )}

              {/* TABLE */}
              {!loading && !error && data.length > 0 && (
                <table className="nhrc-bp-table">
                  <thead>
                    <tr>
                      <th style={{ textAlign: "left" }}>Employee Name</th>
                      <th>Job Role</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.map((emp, index) => {
                      const profileId = emp.id || emp.profile_id;
                      return (
                        <tr key={profileId || index}>
                          <td style={{ textAlign: "left" }}>
                            {index + 1}. {emp.employee_name || emp.name || "N/A"}
                          </td>
                          <td>{emp.designation || "N/A"}</td>
                          <td>
                            <button
                              className="nhrc-bp-btn nhrc-bp-btn-view"
                              onClick={() => handleView(emp)}
                            >
                              View
                            </button>
                            <button
                              className="nhrc-bp-btn nhrc-bp-btn-delete"
                              onClick={() => handleDelete(profileId)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BlackProfile;